module.exports = __webpack_public_path__ + "assets/img/fireworks.50326357.gif";